import {
  getConfidenceCssColor,
  normalizeConfidence,
} from './confidence';

interface RoleAssignmentIndicatorProps {
  assigned: boolean;
  confidence: number | null;
  size?: number;
  surface?: 'transparent' | 'dark';
}

export default function RoleAssignmentIndicator({
  assigned,
  confidence,
  size = 16,
  surface = 'transparent',
}: RoleAssignmentIndicatorProps) {
  const surfaceClassName = surface === 'dark' ? 'bg-gray-90' : '';
  const radius = size * 0.375;
  const strokeWidth = Math.max(1.5, size * 0.1875);
  const circumference = 2 * Math.PI * radius;

  if (!assigned) {
    return (
      <span
        className={`inline-flex items-center justify-center rounded-full ${surfaceClassName}`}
        style={{ width: size, height: size }}
      >
        <svg
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
          aria-hidden
          className="shrink-0"
        >
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke="currentColor"
            strokeWidth={Math.max(1.25, size * 0.09375)}
            fill="none"
            strokeLinecap="round"
            className="text-gray-45"
          />
        </svg>
      </span>
    );
  }

  const normalizedConfidence =
    confidence === null ? 1 : normalizeConfidence(confidence);
  const strokeDashoffset = circumference * (1 - normalizedConfidence);
  const strokeColor =
    confidence === null ? '#ffffff' : getConfidenceCssColor(confidence);

  return (
    <span
      className={`inline-flex items-center justify-center rounded-full ${surfaceClassName}`}
      style={{ width: size, height: size }}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        aria-hidden
        className="shrink-0"
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
    </span>
  );
}
